import React from "react";
import Header from "@/components/forza/Header";
import Hero from "@/components/forza/Hero";
import About from "@/components/forza/About";
import Features from "@/components/forza/Features";
import Rules from "@/components/forza/Rules";
import Staff from "@/components/forza/Staff";
import Connect from "@/components/forza/Connect";
import Gallery from "@/components/forza/Gallery";
import Faq from "@/components/forza/Faq";
import Footer from "@/components/forza/Footer";
import Ribbon from "@/components/forza/Ribbon";

export default function Landing() {
    return (
        <main className="relative bg-[#0D0D0D] text-white overflow-hidden">
            <Header />
            <Hero />
            <Ribbon />
            <About />
            <Features />
            <Rules />
            <Staff />
            <Connect />
            <Gallery />
            <Faq />
            <Footer />
        </main>
    );
}
